





















































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { TRANSFORMERS, ITransformerSettings, TRANSFORMER } from '@/helpers/transformer'
import { FILTER_RULES_FIELDS, FieldTypes } from '@/helpers/filter-rules'
import { TrackFieldsLabels, TrackFields } from '@/constants'
import { ILabelValue } from '@/interfaces/generic'

@Component({
  components: {
    ColorPicker: require('@/components/ColorPicker').default
  }
})
export default class TransformerOptions extends Vue {
  @Prop({
    required: true
  })
  transformer: TRANSFORMERS

  fieldLabels = TrackFieldsLabels

  values: any[] = []

  get allFields(): any[] {
    if (!this.transformer) return []

    return TRANSFORMER[this.transformer].fields.map((f, i) => {
      return {
        index: i,
        field: f
      }
    })
  }

  get fieldFields(): any[] {
    return this.allFields.filter(f => f.field.type === FieldTypes.Field)
  }

  get stringFields(): any[] {
    return this.allFields.filter(f => f.field.type === FieldTypes.String || f.field.type === FieldTypes.Date)
  }

  get selectFields(): any[] {
    return this.allFields.filter(f => f.field.type === FieldTypes.Select)
  }

  get colorFields(): any[] {
    return this.allFields.filter(f => f.field.type === FieldTypes.Color)
  }

  get numberFields(): any[] {
    return this.allFields.filter(f => f.field.type === FieldTypes.Number)
  }

  get booleanFields(): any[] {
    return this.allFields.filter(f => f.field.type === FieldTypes.Boolean)
  }

  get tagsFields(): any[] {
    return this.allFields.filter(f => f.field.type === FieldTypes.Tags)
  }

  getAvailableFields(type: FieldTypes | null, index: number): string[] {
    const hiddenFields: TrackFields[] | undefined = TRANSFORMER[this.transformer].fields[index].hiddenFields

    return Object.keys(FILTER_RULES_FIELDS)
      .filter(field => type === null || FILTER_RULES_FIELDS[field].type === type)
      .filter(field => hiddenFields ? !hiddenFields.includes(field as TrackFields) : true)
  }

  selectOptions(index: number): ILabelValue[] {
    const values = TRANSFORMER[this.transformer].fields[index].values

    if (!values) return []

    return values
  }

  fieldType(index: number): FieldTypes {
    const fieldType = TRANSFORMER[this.transformer].fields[index].fieldType

    if (!fieldType) return FieldTypes.String

    return fieldType
  }

  emitSettings() {
    if (this.allFields.length === 0 || this.values.every(x => x !== null)) {
      this.$emit('input', {
        values: this.values
      } as ITransformerSettings)
    }
  }

  setDefaults() {
    if (!this.transformer) return

    for (let i = 0; i < TRANSFORMER[this.transformer].fields.length; i++) {
      if (TRANSFORMER[this.transformer].fields[i].type === FieldTypes.Boolean) {
        this.values[i] = false
      }

      if (TRANSFORMER[this.transformer].fields[i].type === FieldTypes.String) {
        this.values[i] = ''
      }

      if (TRANSFORMER[this.transformer].fields[i].type === FieldTypes.Tags) {
        this.values[i] = []
      }

      if (TRANSFORMER[this.transformer].fields[i].hasOwnProperty('default')) {
        this.values[i] = TRANSFORMER[this.transformer].fields[i].default
      }
    }
  }

  async created() {
    if (!this.transformer) { // Still not sure how this can occur
      this.$emit('no-transformer')

      return
    }

    this.values = new Array(TRANSFORMER[this.transformer].fields.length).fill(null)

    this.setDefaults()

    this.emitSettings()
  }

  @Watch('values', { deep: true })
  watchFields() {
    this.emitSettings()
  }
}
